import { ADMIN_API_BASE } from "../config";
import { clearCachedEmployeeEmail, markSignedOut } from "./identity";
import { clearReturnTo } from "./return-to";

interface SignOutLocation {
  readonly origin: string;
  assign(url: string): void;
  reload(): void;
}

/**
 * Return the cookie-clearing logout URL when the API is on this SPA's origin.
 * Local development uses a separate API origin, where following the backend
 * redirect would leave the SPA, so stub-mode logout falls back to reloading.
 */
export function resolveAdminLogoutUrl(apiBase: string, currentOrigin: string): string | null {
  const origin = new URL(currentOrigin).origin;
  const logoutUrl = new URL("/api/auth/google/logout", apiBase.trim() || origin);
  return logoutUrl.origin === origin ? logoutUrl.href : null;
}

/** End both forms of admin identity: the local stub and the cloud OAuth cookie. */
export function signOutAdmin(
  location: SignOutLocation = window.location,
  apiBase: string = ADMIN_API_BASE,
): void {
  markSignedOut();
  clearCachedEmployeeEmail();
  // Logout also lands on "/", which is exactly where a remembered deep link is
  // restored — drop it, so signing out cannot bounce the operator back into the
  // page they were last signed in for (lib/return-to.ts).
  clearReturnTo();

  const logoutUrl = resolveAdminLogoutUrl(apiBase, location.origin);
  if (logoutUrl) {
    location.assign(logoutUrl);
    return;
  }

  location.reload();
}
